import api from './api';

export const contactUs = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Utility/ContactUs`, value, config);
    }
}
